import { usePetitionDetailsPageFcm } from 'src/app/pages/petition/details/pageContext';

export function useShowNewlyCreatedPetitions(): boolean {
	const { newlyCreatedPetitionsEnabled } = usePetitionDetailsPageFcm();

	return newlyCreatedPetitionsEnabled;
}
